import React from 'react';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import { useCurrency, useI18n, useSelector } from 'Hooks';

import { CURRENCY } from '../../../__queries__';
import Collapsible from '../Collapsible';
import { Button, ItemName, ItemValue, Row, Wrapper } from './styles';

export interface ListItem {
  id: string;
  name: string;
  value?: number;
  isLoading?: boolean;
  disableAdd?: boolean;
  isActive?: boolean;
  handleClick?: () => void;
  addHandler?: (id: string, name: string) => void | null;
  removeHandler?: (id: string) => void | null;
  editHandler?: (id: string) => void | null;
}

export interface Props {
  title?: string;
  titleRight?: string;
  isPrice?: boolean;
  maxWidth?: number;
  listItems: ListItem[];
  handleAddAll?: ((listItems: ListItem[]) => void) | null;
}

const List = ({
  title,
  titleRight,
  listItems,
  maxWidth = 575,
  isPrice = false,
  handleAddAll,
}: Props) => {
  const currency = useSelector((state) => state.currency);
  const { formatAmount } = useCurrency();
  const { t } = useI18n();

  const allAdded = listItems.filter((item) => item.addHandler).length < 1;

  const buttons: any = [];

  if (handleAddAll) {
    buttons.push({
      text: t('PIM.AddAll'),
      disabled: allAdded,
      handleClick: () => handleAddAll(listItems),
    });
  }

  return (
    <Collapsible isOpen={true} title={title ?? ''} titleRight={titleRight ?? ''} buttons={buttons}>
      <Wrapper blockMaxWidth={maxWidth}>
        {!!listItems?.length &&
          listItems.map(
            ({
              id,
              name,
              value,
              isActive = false,
              handleClick,
              addHandler,
              editHandler,
              removeHandler,
              isLoading = false,
              disableAdd = false,
            }) => (
              <Row
                key={id || name}
                onClick={() => (handleClick ? handleClick() : null)}
                isClickable={Boolean(handleClick)}
                isActive={isActive}>
                <ItemName>{name}</ItemName>
                {value !== undefined && value !== 0 && (
                  <ItemValue>{isPrice ? formatAmount(value) : value}</ItemValue>
                )}
                {editHandler && (
                  <Button color="#1642be" onClick={() => editHandler(id)}>
                    {t('General.Edit')}
                  </Button>
                )}
                {!removeHandler && addHandler && (
                  <Button
                    isLoading={isLoading || disableAdd}
                    color="#1642be"
                    onClick={() => addHandler(id, name)}>
                    {t('General.Add')}
                  </Button>
                )}
                {removeHandler && (
                  <Button isLoading={isLoading} color="#e3273b" onClick={() => removeHandler(id)}>
                    {t('General.Remove')}
                  </Button>
                )}
                {handleClick && <ArrowForwardIcon />}
              </Row>
            ),
          )}
      </Wrapper>
    </Collapsible>
  );
};

export default List;
